import React from "react";
import PropTypes from "prop-types";

import { /* Popper, */ Button } from "../../../../components/simple";
// import SVG from "../../../../components/SVG";
// import { PLATFORMS } from "../platforms";

// import { defaultOptions } from "../../../../helpers/popoverOptions";

import styles from "../push-modal.module.scss";
import localStyles from "./limit-warning.module.scss";

const LimitWarning = ({ onPushAnyway, onContactMe, onShow }) => {
  return (
    <>
      <div
        className={`${styles["limit-warning"]} ${
          !onShow ? styles["slide-to-left"] : ""
        }`}
      >
        <div className={`${styles.header} ${localStyles.header}`}>
          <span>
            You are on a freemium plan, so your reach is limited to 200 location
            points.
            <Button
              className={`button ${localStyles["button-push"]}`}
              onClick={onPushAnyway}
            >
              Push anyway
            </Button>
          </span>
        </div>
        <div className={localStyles["full-reach-container"]}>
          <span>Want to have full reach and access to more features?</span>
          <Button
            className={`button button-outline ${localStyles["button-contact"]}`}
            onClick={onContactMe}
          >
            Contact me for an upgrade
          </Button>
        </div>
      </div>
    </>
  );
};

LimitWarning.propTypes = {
  audience: PropTypes.shape({ name: PropTypes.string }),
  onPushAnyway: PropTypes.func,
  onContactMe: PropTypes.func,
  onShow: PropTypes.bool
};

LimitWarning.defaultProps = {
  audience: { name: "" },
  onPushAnyway: () => {},
  onContactMe: () => {},
  onShow: false
};

export default LimitWarning;
